import { Button } from '@myosh/odin-components';
import { memo } from 'react';
import MyoshBowtieLogo from '../../assets/svg/myosh-bowtie-logo.svg';
import Settings from '../../components/header/settings.component';

const containerStyles =
  'bt-mx-auto bt-my-0 bt-flex bt-h-screen bt-w-full bt-flex-col bt-items-center bt-justify-center';

interface ErrorPageProps {
  message: string;
  showHeader?: boolean;
  actionLabel?: string;
  onActionClick?: () => void;
}

const ErrorPage = ({ message, showHeader = true, actionLabel, onActionClick }: ErrorPageProps) => {
  return (
    <div data-cy="configuration-error" className="bt-flex bt-h-screen bt-w-full bt-flex-col">
      {showHeader && (
        <div
          data-cy="error-header-bar"
          className="bt-sticky bt-left-0 bt-top-0 bt-z-[1300] bt-mt-0 bt-flex bt-h-14 bt-justify-between bt-bg-mono-1 bt-px-2 bt-pt-2"
        >
          <img src={MyoshBowtieLogo} width={90} alt="Myosh Bowtie Logo" data-cy="error-header-logo" />
          <Settings showOnlyAboutOption />
        </div>
      )}
      <div className={containerStyles}>
        <span>{message}</span>
        {actionLabel && onActionClick && (
          <Button type="primary" onClick={onActionClick} style={{ marginTop: '12px' }} data-cy="reload">
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(ErrorPage);
